import { createSlice } from '@reduxjs/toolkit';
import { get_file_order, get_folder_order, get_folder_thunk } from './folderThunk';
import { fileType } from '../../common/common';

const initialState = {
  error: null,
  loading: false,
  folders: [],  // Ensure folders is initialized as an empty array
  files:[],
  activeFolder: null, // Track the active folder
  clipboard: null, // Stores cut or copied item
  selectedFolder: null,
  selectedFile: null,
  folderOrderIds: null,
  fileOrderIds: null
};

// Helper function to save folders to localStorage
const saveFoldersToLocalStorage = (folders) => {
  localStorage.setItem('folder', JSON.stringify(folders));
};

// Helper function to load folders from localStorage
const loadFoldersFromLocalStorage = () => {
  let folders = localStorage.getItem('folder');

  folders = JSON.parse(folders)
  return folders ? folders: [];
};

export const loadFilesFromLocalStorage = (data) => {
  let folders = localStorage.getItem('folder');
  folders = JSON.parse(folders)
  if(data.parentId){
  let files = folders ? folders.filter((folder) => {
    return folder.id === data.parentId
  })?.[0]?.children: [];

  return files
  }else{
    let files =  folders ? folders.filter(folder => {
      return folder.type === fileType[1]
    }
    ): [];
    return files
  }
};

// Utility to recursively add a subfolder to a specific folder
const addFolderToFolder = (folders, parentId, newFolder) => {
  return folders.map(folder => {
    if (folder.id === parentId) {
      return {
        ...folder,
        children: [...(folder.children || []), newFolder],
      };
    } else if (folder.children) {
      return {
        ...folder,
        children: addFolderToFolder(folder.children, parentId, newFolder),
      };
    }
    return folder;
  });
};

const deleteFolderFromFolder = (folders, parentId, folderIdToDelete) => {

  return folders.map(folder => {
    if (folder.id === folderIdToDelete) {
      // If the folder to delete is found at the current level, return null to remove it
      return null;
    } else if (folder.children) {
      // If folder has children, recurse to find and delete the folder
      return {
        ...folder,
        children: deleteFolderFromFolder(folder.children, parentId, folderIdToDelete),
      };
    }
    return folder;
  }).filter(folder => folder !== null); // Filter out nulls (deleted folders)
};

// Function to update a folder's name in the folder tree
const updateFolderInFolder = (folders, parentId, updatedFolder) => {

  return folders.map(folder => {
    if (folder.id === updatedFolder.id) {
      // If the folder matches, update its name
      return {
        ...folder,
        name: updatedFolder.renameText,
      };
    } else if (folder.children) {
      // If folder has children, recurse to update the folder
      return {
        ...folder,
        children: updateFolderInFolder(folder.children, parentId, updatedFolder),
      };
    }
    return folder;
  });
};
const updateFileColorInFolder = (folders, parentId, updatedFolder) => {

  return folders.map(folder => {
    if (folder.id === updatedFolder.id) {
      // If the folder matches, update its name
      return {
        ...folder,
        backgroundColor: updatedFolder.color,
      };
    } else if (folder.children) {
      // If folder has children, recurse to update the folder
      return {
        ...folder,
        children: updateFileColorInFolder(folder.children, parentId, updatedFolder),
      };
    }
    return folder;
  });
};
const updateShortcutInFolder = (folders, parentId, updatedFolder) => {
  return folders.map(folder => {
    if (folder.id === updatedFolder.id) {
      // If the folder matches, update its name
      return {
        ...folder,
        shortcut: updatedFolder.shortcut,
      };
    } else if (folder.children) {
      // If folder has children, recurse to update the folder
      return {
        ...folder,
        children: updateShortcutInFolder(folder.children, parentId, updatedFolder),
      };
    }
    return folder;
  });
};

// Sort folders by createdAt in descending order
const sortFoldersByCreatedAt = (folders) => {
  if(!folders || folders?.length === 0) return [];
  return folders.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
};

// const sortFoldersByCreatedAtAndOrder = (folders) => {
//   if (!folders?.length) return [];
  
//   try {
//     const folderOrderIds = JSON.parse(localStorage.getItem('folderOrderIds')) || [];
//     return folderOrderIds.length ? 
//       folders.sort((a, b) => folderOrderIds.indexOf(a.id) - folderOrderIds.indexOf(b.id)) :
//       folders.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
//   } catch {
//     return folders.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
//   }
// };

const sortFoldersByCreatedAtAndOrder = (folders) => {
  if (!folders?.length) return [];
  
  try {
    const folderOrderIds = JSON.parse(localStorage.getItem('folderOrderIds')) || [];
    
    if (!folderOrderIds.length) {
      return folders.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    }

    // Split folders into two groups
    const foldersInOrder = folders.filter(folder => folderOrderIds.includes(folder.id));
    const foldersNotInOrder = folders.filter(folder => !folderOrderIds.includes(folder.id));

    // Sort unordered folders by creation date
    const sortedFoldersNotInOrder = foldersNotInOrder.sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );

    // Sort ordered folders by their position in folderOrderIds
    const sortedFoldersInOrder = foldersInOrder.sort(
      (a, b) => folderOrderIds.indexOf(a.id) - folderOrderIds.indexOf(b.id)
    );

    // Combine arrays with unordered folders first
    return [...sortedFoldersNotInOrder, ...sortedFoldersInOrder];
    
  } catch {
    return folders.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  }
};

// const sortFilesByCreatedAtAndOrder = (files) => {
//   if (!files?.length) return [];
  
//   try {
//     const fileOrders = JSON.parse(localStorage.getItem('fileOrderIds')) || {};
//     const folderId = files[0]?.parentId || "default-folder";
//     const currentFolderOrder = fileOrders[folderId] || [];

//     return currentFolderOrder.length ?
//       files.sort((a, b) => currentFolderOrder.indexOf(a.id) - currentFolderOrder.indexOf(b.id)) :
//       files.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
//   } catch {
//     return files.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
//   }
// };

const sortFilesByCreatedAtAndOrder = (files) => {
  if (!files?.length) return [];
  
  try {
    const fileOrders = JSON.parse(localStorage.getItem('fileOrderIds')) || {};
    const folderId = files[0]?.parentId || "default-folder";
    const currentFolderOrder = fileOrders[folderId] || [];

    if (!currentFolderOrder.length) {
      return files.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    }

    // Split files into two groups
    const filesInOrder = files.filter(file => currentFolderOrder.includes(file.id));
    const filesNotInOrder = files.filter(file => !currentFolderOrder.includes(file.id));

    // Sort unordered files by creation date
    const sortedFilesNotInOrder = filesNotInOrder.sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );

    // Sort ordered files by their position in currentFolderOrder
    const sortedFilesInOrder = filesInOrder.sort(
      (a, b) => currentFolderOrder.indexOf(a.id) - currentFolderOrder.indexOf(b.id)
    );

    // Combine arrays with unordered files first
    return [...sortedFilesNotInOrder, ...sortedFilesInOrder];

  } catch {
    return files.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  }
};

// Thunks
const getFolderCases = (builder) => {
  builder
    .addCase(get_folder_thunk.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(get_folder_thunk.fulfilled, (state, action) => {
      // Sort folders after fetching from the API
      state.folders = sortFoldersByCreatedAtAndOrder(action.payload.data.response);
      state.loading = false;
      if(state.activeFolder === "default-folder"){
        state.files = sortFilesByCreatedAtAndOrder(loadFilesFromLocalStorage({parentId:null}));;
      }
      else{
        if(state.activeFolder){
          state.files = sortFilesByCreatedAtAndOrder(loadFilesFromLocalStorage({parentId:state.activeFolder}));
        }
      }
    })
    .addCase(get_folder_thunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || "Redux Cases Error";
    });
};
// Redux Builder Cases
const getFolderOrderIdCases = (builder) => {
  builder
      .addCase(get_folder_order.pending, (state) => {
          state.loading = true;
          state.error = null;
      })
      .addCase(get_folder_order.fulfilled, (state, action) => {
          state.folderOrderIds = action.payload?.data?.response?.folderOrder || [];
          state.loading = false;
      })
      .addCase(get_folder_order.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload || "Redux Cases Error";
          state.folderOrderIds = []; // Reset to empty array on error
      });
};

const getFileOrderIdCases = (builder) => {
  builder
      .addCase(get_file_order.pending, (state) => {
          state.loading = true;
          state.error = null;
      })
      .addCase(get_file_order.fulfilled, (state, action) => {
          state.fileOrderIds = action.payload || {};
          state.loading = false;
      })
      .addCase(get_file_order.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload || "Redux Cases Error";
          state.fileOrderIds = {}; // Reset to empty object on error
      });
};



const folderSlice = createSlice({
  name: 'folder',
  initialState,
  reducers: {
    addFolder: (state, action) => {
      const { data } = action.payload;

      // Ensure state.folders is an array
      state.folders = state.folders || [];

      if (data?.parentId) {
        let draft = JSON.parse(JSON.stringify(state.folders));
        let updatedFolders = addFolderToFolder(draft, data.parentId, { ...data });
        state.folders = sortFoldersByCreatedAtAndOrder(updatedFolders);  // Sort after adding
      } else {
        state.folders = sortFoldersByCreatedAtAndOrder([ ...state.folders,{ ...data }]);  // Sort after adding
      }

      saveFoldersToLocalStorage(state.folders);
    },

    getFoldersFromLocalStorage: (state) => {
      state.folders = sortFoldersByCreatedAtAndOrder(loadFoldersFromLocalStorage());  // Sort after loading
    },

    setFiles : (state,action) => {
      state.files = sortFilesByCreatedAtAndOrder(loadFilesFromLocalStorage({parentId:action.payload}));;
    },

    setActiveFolder: (state, action) => {
      state.activeFolder = action.payload;
    },

    setSelectedFolder: (state, action) => {
      state.selectedFolder = action.payload;
    },
    setSelectedFile: (state, action) => {
      state.selectedFile = action.payload;
    },

    renameFolderOrTodo: (state, action) => {
      const { itemData, renameText } = action.payload;
      const updatedFolder = { ...itemData, renameText };
      state.folders = updateFolderInFolder(state.folders, itemData.parentId, updatedFolder);
      state.folders = sortFoldersByCreatedAtAndOrder(state.folders);  // Sort after renaming
      saveFoldersToLocalStorage(state.folders);
    },
    updateBackgroundColor: (state, action) => {
      const { item, color } = action.payload;
      const updatedFolder = { ...item, color };
      state.folders = updateFileColorInFolder(state.folders, item.parentId, updatedFolder);
      state.folders = sortFoldersByCreatedAtAndOrder(state.folders);  // Sort after renaming
      saveFoldersToLocalStorage(state.folders);

    },
    
    // Action to delete a folder or todo
    deleteFolderOrTodo: (state, action) => {
      const { data } = action.payload;
      state.folders = deleteFolderFromFolder(state.folders, data.parentId, data.id);
      state.folders = sortFoldersByCreatedAtAndOrder(state.folders);  // Sort after deleting
      saveFoldersToLocalStorage(state.folders);
    },
    changeFileColor: (state, action) => {
      const { item, color } = action.payload;
      state.files = state.files.map(file => {
        if (file.id === item.id) {
          return {
            ...file,
            backgroundColor: color,
          };
        }
        return file;
      });
    },
    setShortCut: (state, action) => {
      const { item, shortcut } = action.payload;
      const updatedFolder = { ...item, shortcut };
      state.folders = updateShortcutInFolder(state.folders, item.parentId, updatedFolder);
      state.folders = sortFoldersByCreatedAtAndOrder(state.folders);  // Sort after renaming
      saveFoldersToLocalStorage(state.folders);
    },

    setFolderOrderIds : (state, action) => {
      state.folderOrderIds = action.payload;
      localStorage.setItem('folderOrderIds', JSON.stringify(action.payload));
    },
    // deleteFolderId: (state, action) => {
    //   const folderOrderIds = [...state.folderOrderIds];
    //   console.log('action.payload',action.payload)
    //   folderOrderIds.splice(folderOrderIds.indexOf(action.payload), 1);
    //   state.folderOrderIds = folderOrderIds;
    //   localStorage.setItem('folderOrderIds', JSON.stringify(folderOrderIds));
    // },

    setFileOrderIds: (state, action) => {
      const { folderId, fileIds } = action.payload;
      state.fileOrderIds = {
        ...state.fileOrderIds,
        [folderId]: fileIds
      };
      localStorage.setItem('fileOrderIds', JSON.stringify(state.fileOrderIds));
    },
    // deleteFolderId: (state, action) => {
    //   const folderOrderIds = [...state.folderOrderIds];
    //   console.log('action.payload',action.payload)
    //   folderOrderIds.splice(folderOrderIds.indexOf(action.payload), 1);
    //   state.folderOrderIds = folderOrderIds;
    //   localStorage.setItem('fileOrderIds', JSON.stringify(folderOrderIds));
    // },
    clearFiles: (state) => {
      state.files = [];
    },

    clearFolder: (state) => {
      state.folders = [];
      state.activeFolder = null;
      state.selectedFolder = null;
      state.clipboard = null;
      state.files = [];
      state.selectedFile = null;
      state.folderOrderIds = [];
    },

  },
  extraReducers: (builder) => {
    getFolderCases(builder);
    getFolderOrderIdCases(builder);
    getFileOrderIdCases(builder);
  },
});

export const {
  addFolder,
  getFoldersFromLocalStorage,
  setFiles,
  setActiveFolder,
  setSelectedFolder,
  setSelectedFile,
  renameFolderOrTodo,
  deleteFolderOrTodo,
  clearFolder,
  updateBackgroundColor,
  editFileName,
  changeFileColor,
  deleteFile,
  setShortCut,
  setFolderOrderIds,
  addFolderId,
  deleteFolderId,
  setFileOrderIds,
  clearFiles
} = folderSlice.actions;

export default folderSlice.reducer;



// New action for setting item in clipboard for cut/copy
//   cutFolderOrTodo: (state, action) => {
//     const { id, isFolder } = action.payload;
//     state.clipboard = { id, isFolder, action: 'cut' };
//   },

//   copyFolderOrTodo: (state, action) => {
//     const { id, isFolder } = action.payload;
//     state.clipboard = { id, isFolder, action: 'copy' };
//   },

//   // New action for pasting clipboard item into a folder
//   pasteTodoOrFolder: (state, action) => {
//     const { targetFolderId } = action.payload;
//     if (state.clipboard) {
//       const { id, isFolder, action: clipboardAction } = state.clipboard;
//       if (isFolder) {
//         const folder = state.folders.find(folder => folder.id === id);
//         if (folder) {
//           if (clipboardAction === 'cut') {
//             state.folders = state.folders.filter(f => f.id !== id); // Remove cut folder from the list
//           }
//           // Add the folder to the target folder
//           folder.parentId = targetFolderId;
//           state.folders.push(folder);
//         }
//       } else {
//         const todo = state.todos.find(todo => todo.id === id);
//         if (todo) {
//           if (clipboardAction === 'cut') {
//             state.todos = state.todos.filter(t => t.id !== id); // Remove cut todo from the list
//           }
//           // Add the todo to the target folder
//           todo.parentId = targetFolderId;
//           state.todos.push(todo);
//         }
//       }
//       state.clipboard = null; // Clear the clipboard after pasting
//     }
//   },